import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/core';
export var AI_CHAT_ACCOUNTING_SUBSCRIPTION_API = 'AI_CHAT_ACCOUNTING_SUBSCRIPTION_API';
export var AIChatAccountingSubscriptionApi = /*#__PURE__*/function () {
  function AIChatAccountingSubscriptionApi(axiosInstance) {
    _classCallCheck(this, AIChatAccountingSubscriptionApi);

    this.axiosInstance = axiosInstance;
  }

  _createClass(AIChatAccountingSubscriptionApi, [{
    key: "getCurrentSubscription",
    value: function () {
      var _getCurrentSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _parsedBodyResponse$d, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.axiosInstance) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Result.ok(null));

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.axiosInstance.get('/me/subscription');

              case 5:
                jsonResponse = _context.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context.abrupt("return", Result.ok((_parsedBodyResponse$d = parsedBodyResponse.data) !== null && _parsedBodyResponse$d !== void 0 ? _parsedBodyResponse$d : null));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", Result.ok(null));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function getCurrentSubscription() {
        return _getCurrentSubscription.apply(this, arguments);
      }

      return getCurrentSubscription;
    }()
  }]);

  return AIChatAccountingSubscriptionApi;
}();